import apiManager from './apiManager'
export default class GoogleIdentityService {
  constructor() {
    this.onLoadGoogleDone = false
    this.onLoginInitDone = false
    this.initialized = false

    if (document.readyState === 'complete') {
      this.onLoadGoogle()
    }
    window.onload = () => {
      this.onLoadGoogle()
    }
  }
  async onLoadGoogle(tries = 0) {
    if (window.google && window.google.accounts) {
      this.onLoadGoogleDone = true
      this.init()
    } else {
      if (tries < 3) {
        setTimeout(() => this.onLoadGoogle(tries + 1), 1000)
      }
    }
  }

  onLoginInit() {
    this.onLoginInitDone = true
    this.init()
  }

  init() {
    if (this.onLoadGoogleDone && this.onLoginInitDone && !this.initialized) {
      this.initialized = true
      window.google?.accounts.id.initialize({
        client_id: window.rurality.auth.config.client_id,
        callback: data => {
          this.handleCredentialResponse(data)
        },
      })
      window.google.accounts.id.prompt()
      this.isReady = true

      this.launchPAuthGoogleIdentityReady()
    }
  }

  handleCredentialResponse(data) {
    const responsePayload = this.decodeJWT(data.credential)
    this.signIn(responsePayload)
  }

  decodeJWT(token) {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''),
    )
    return JSON.parse(jsonPayload)
  }

  async signIn(userData) {
    const url = `//${window.ER.uri.main.authority}${window.ER.uri.prefix}dynamic/g_connect`
    const response = await apiManager({
      url,
      data: userData,
    })
    const responseText = await response.json()

    if (responseText.conflict === true) {
      return this.conflict()
    } else if (responseText.emailHasError === true) {
      return this.emailHasError()
    } else if (responseText.success === true) {
      try {
        const googleIdentitySignedInEvent = new CustomEvent(
          'GoogleIdentityService:userSignedIn',
        )
        document.dispatchEvent(googleIdentitySignedInEvent)
      } catch (e) {
        return window.ER.util.refresh()
      }
    } else if (responseText.success === false) {
      return this.signUp(userData)
    }
  }

  conflict() {
    return (top.location =
      '//' +
      window.ER.uri.main.authority +
      window.ER.uri.prefix +
      'static/conflict?who=google')
  }

  emailHasError() {
    return (top.location =
      '//' +
      window.ER.uri.main.authority +
      window.ER.uri.prefix +
      'traveler/email-error')
  }

  badEmail() {
    return (top.location =
      '//' +
      window.ER.uri.main.authority +
      window.ER.uri.prefix +
      'static/conflict?cause=mail&who=google')
  }

  async signUp(userData) {
    const url = `//${window.ER.uri.main.authority}${window.ER.uri.prefix}dynamic/google_prepare_signup`
    const response = await apiManager({
      url,
      data: userData,
    })
    const responseText = await response.text()
    if (responseText === 'bad_email') {
      return this.badEmail()
    } else if (
      typeof window.var_static !== 'undefined' &&
      window.var_static === 1
    ) {
      this.launchSignUpEvent('success', responseText)
    } else {
      this.launchSignUpEvent('openLoginPopup', responseText)
    }
  }

  launchSignUpEvent(ev, responseText) {
    const googleIdentitySignUpEvent = new CustomEvent(
      'GoogleIdentityService:userSignedUp',
      {
        detail: {
          response: ev,
          responseText,
        },
        bubbles: true,
        view: window,
      },
    )
    document.dispatchEvent(googleIdentitySignUpEvent)
  }

  launchPAuthGoogleIdentityReady() {
    const googleIdentitySignedInEvent = new CustomEvent(
      'p-auth-google:google-identity-ready',
    )
    document.dispatchEvent(googleIdentitySignedInEvent)
  }
}

;(() => {
  function register() {
    window.rurality = window.rurality || {}
    window.rurality.auth = window.rurality.auth || {}

    window.rurality.auth.GoogleIdentityService = new GoogleIdentityService()
    const googleIdentityLoadedEvent = new CustomEvent(
      'GoogleIdentityService:loaded',
    )
    document.dispatchEvent(googleIdentityLoadedEvent)
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', register, { once: true })
    const removeListener = () => {
      document.removeEventListener('DOMContentLoaded', register, { once: true })
      window.removeEventListener('pagehide', removeListener)
    }
    window.addEventListener('pagehide', removeListener, { once: true })
  } else {
    register()
  }
})()
